import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const LS_PREFIX = 'ranking_visto_';

function prevMonthISO() {
  const now = new Date();
  return new Date(Date.UTC(now.getFullYear(), now.getMonth() - 1, 1))
    .toISOString()
    .split('T')[0];
}

function prevMonthKey() {
  const iso = prevMonthISO();
  return iso.slice(0, 7); // "YYYY-MM"
}

export function useRankingResultado(userId) {
  const [resultado, setResultado] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!userId) return;
    if (localStorage.getItem(LS_PREFIX + prevMonthKey())) return;

    async function fetchResultado() {
      const { data } = await supabase
        .from('leaderboard_history')
        .select('*')
        .eq('user_id', userId)
        .eq('month', prevMonthISO())
        .maybeSingle();
      if (data && data.points > 0) {
        setResultado(data);
        setShowModal(true);
      }
    }

    fetchResultado();
  }, [userId]);

  function dismiss() {
    localStorage.setItem(LS_PREFIX + prevMonthKey(), '1');
    setShowModal(false);
  }

  async function fetchMes(monthISO) {
    const { data } = await supabase
      .from('leaderboard_history')
      .select('*')
      .eq('user_id', userId)
      .eq('month', monthISO)
      .single();
    if (data) setResultado(data);
    return data;
  }

  return { resultado, showModal, dismiss, fetchMes };
}
